import { render, staticRenderFns } from "./ReportEstatusGestion.vue?vue&type=template&id=49018962&scoped=true"
import script from "./ReportEstatusGestion.vue?vue&type=script&lang=ts"
export * from "./ReportEstatusGestion.vue?vue&type=script&lang=ts"
import style0 from "./ReportEstatusGestion.vue?vue&type=style&index=0&id=49018962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49018962",
  null
  
)

export default component.exports